const colors = {
  cyan: '#00e5ff',
  text: '#F5F5FC',
  panel: '#202329',
  panelDark: '#17191d',
  background: '#090a0c',
  border: '#3b4048',
  muted: '#a9b0bb',
  success: '#65A7FF',
  warning: '#FFD166',
  danger: '#FF7B7B',
}

const inputStyle = {
  backgroundColor: '#0f1114',
  border: `1px solid ${colors.border}`,
  borderRadius: '2px',
  color: colors.text,
}

const buttonStyle = {
  backgroundColor: colors.panelDark,
  border: `1px solid ${colors.border}`,
  borderRadius: 0,
  color: colors.text,
  fontSize: '.8em',
  height: '3em',
  margin: '.1em',
}

const primaryButtonStyle = {
  ...buttonStyle,
  backgroundColor: colors.cyan,
  color: colors.panelDark,
}

const sectionStyle = {
  backgroundColor: colors.panelDark,
  border: `1px solid ${colors.border}`,
  marginBottom: '1em',
  padding: '1em',
}

const titleStyle = {
  color: colors.cyan,
  fontSize: '1.45em',
  fontWeight: '500',
  margin: 0,
}

const labelStyle = {
  color: colors.muted,
  fontSize: '.76em',
  textTransform: 'uppercase',
}

function statusColor(status) {
  if (status === 'Screen down' || status === 'Screen down - awaiting parts' || status === 'TMS down') return colors.danger
  if (status === 'Solved') return colors.success
  if (status === 'Solving remotely' || status === 'Solving - visit needed' || status === 'Awaiting parts' || status === 'Reviewing') return colors.cyan
  if (status === 'Monitoring') return colors.warning
  return colors.text
}

export {
  colors,
  inputStyle,
  buttonStyle,
  primaryButtonStyle,
  sectionStyle,
  titleStyle,
  labelStyle,
  statusColor,
}
